import React, { useState, useEffect, useRef  } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import config from "./config";

const SiteSelection = () => {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [clock, setClock] = useState("");

    const [siteQuery, setSiteQuery] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const filteredSites = sites.filter((s) => {
        const q = siteQuery.trim().toLowerCase();
        if (!q) return true;
        return String(s.displayName || "").toLowerCase().includes(q);
    });

    useEffect(() => {
        const onDown = (e) => {
            if (!dropdownRef.current) return;
            if (!dropdownRef.current.contains(e.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", onDown);
        return () => document.removeEventListener("mousedown", onDown);
    }, []);


    useEffect(() => {
        const onDown = (e) => {
            if (!dropdownRef.current) return;
            if (!dropdownRef.current.contains(e.target)) setIsDropdownOpen(false);
        };
        document.addEventListener("mousedown", onDown);
        document.addEventListener("touchstart", onDown);
        return () => {
            document.removeEventListener("mousedown", onDown);
            document.removeEventListener("touchstart", onDown);
        };
    }, []);

  const navigate = useNavigate();
  const location = useLocation();

  // Load sites or validate GUID
  useEffect(() => {
    const guid = new URLSearchParams(location.search).get("guid");
    if (guid) {
      fetch(`${config.apiUrl}/validateGuid?guid=${guid}`)
          .then((r) => { if (!r.ok) throw new Error(); return r.json() })
          .then((data) => {
            if (data.places?.length) navigate(`/enter-car?guid=${guid}`);
            else throw new Error();
          })
          .catch(() => {
            setError("GUID לא תקין. אנא נסו שנית.");
            setIsLoading(false);
          });
    } else {
      fetch(`${config.app.serverUrl}/sites`)
          .then((r) => { if (!r.ok) throw new Error(); return r.json() })
          .then((data) => {
            setSites(data.sites.filter((s) => s.active));
            setIsLoading(false);
          })
          .catch(() => {
            setError("תקלה בטעינת האתרים. אנא נסו שנית.");
            setIsLoading(false);
          });
    }
  }, [location.search, navigate]);

    useEffect(() => {
        if (selectedSite && !filteredSites.some((s) => s.lane_guid === selectedSite)) {
            setSelectedSite("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteQuery]);

    // Clock
  useEffect(() => {
    const iv = setInterval(() => {
      setClock(new Date().toLocaleTimeString("en-GB"));
    }, 1000);
    return () => clearInterval(iv);
  }, []);

  const handleContinue = () => {
    if (!selectedSite) {
      setError("אנא בחרו אתר מהרשימה.");
    } else {
      navigate(`/enter-car?guid=${selectedSite}`);
    }
  };

  return (
      <div
          style={{
            position: "relative",
            width: "100vw",      // ← full viewport width
            height: "100vh",     // ← full viewport height
            margin: 0,
            background: "#FFFFFF",
            overflow: "hidden",
            direction: "rtl",
          }}
      >
        {/* Logo */}
        <img
            src="/logo.png"
            alt="Blue Parking"
            style={{
              display: "block",
              width: 300,
              margin: "72px auto 48px",
            }}
        />

        {isLoading ? (
            <p
                style={{
                  textAlign: "center",
                  color: "#00427C",
                  fontSize: 16,
                }}
            >
              טוען נתונים…
            </p>
        ) : (
            <>
            {error && (
                <p
                    style={{
                        textAlign: "center",
                        color: "#C00",
                        fontSize: 14,
                        margin: "0 16px 24px",
                    }}
                >
                    {error}
                </p>
            )}

            {/* Dropdown */}
                <div ref={dropdownRef} style={{ width: 333, margin: "0 auto 24px", position: "relative" }}>
                    <div
                        style={{
                            height: 48,
                            border: "1px solid #0098CF",
                            borderRadius: 8,
                            background: "#FFF",
                            display: "flex",
                            alignItems: "center",
                            padding: "0 12px",
                            gap: 8,
                            boxSizing: "border-box",
                        }}
                    >
                        <input
                            value={siteQuery}
                            onChange={(e) => {
                                setSiteQuery(e.target.value);
                                setIsDropdownOpen(true);
                                setError("");
                                setSelectedSite(""); // חשוב: בזמן הקלדה ננקה בחירה קודמת
                            }}
                            onFocus={() => setIsDropdownOpen(true)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (filteredSites[0]) {
                                        setSelectedSite(filteredSites[0].lane_guid);
                                        setSiteQuery(filteredSites[0].displayName || "");
                                        setIsDropdownOpen(false);
                                    }
                                }
                                if (e.key === "Escape") setIsDropdownOpen(false);
                            }}
                            placeholder="חפש אתר…"
                            style={{
                                flex: 1,
                                height: "100%",
                                border: "none",
                                outline: "none",
                                fontSize: 16,
                                color: "#00427C",
                                background: "transparent",
                                direction: "rtl",
                            }}
                        />

                        {!!siteQuery && (
                            <button
                                type="button"
                                onClick={() => {
                                    setSiteQuery("");
                                    setSelectedSite("");
                                    setIsDropdownOpen(true);
                                }}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    fontSize: 22,
                                    lineHeight: 1,
                                    color: "#0098CF",
                                    padding: 0,
                                }}
                                aria-label="נקה"
                            >
                                ×
                            </button>
                        )}

                        <div
                            style={{
                                width: 12,
                                height: 8,
                                backgroundImage:
                                    `url("data:image/svg+xml;utf8,` +
                                    `<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8'>` +
                                    `<path d='M1 1l5 6 5-6' stroke='%23009ECF' stroke-width='2' fill='none'/>` +
                                    `</svg>")`,
                                backgroundRepeat: "no-repeat",
                                pointerEvents: "none",
                                opacity: 0.9,
                            }}
                        />
                    </div>

                    {isDropdownOpen && (
                        <div
                            style={{
                                position: "absolute",
                                top: 54,
                                left: 0,
                                right: 0,
                                background: "#fff",
                                border: "1px solid rgba(0,152,207,0.35)",
                                borderRadius: 8,
                                boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                                maxHeight: 240,
                                overflowY: "auto",
                                zIndex: 9999,
                            }}
                        >
                            {filteredSites.length === 0 ? (
                                <div style={{ padding: 12, color: "#00427C", opacity: 0.7 }}>
                                    לא נמצאו תוצאות
                                </div>
                            ) : (
                                filteredSites.map((s) => (
                                    <button
                                        key={s.lane_guid}
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()} // מונע blur לפני click
                                        onClick={() => {
                                            setSelectedSite(s.lane_guid);
                                            setSiteQuery(s.displayName || "");
                                            setIsDropdownOpen(false);
                                            setError("");
                                        }}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "none",
                                            background: selectedSite === s.lane_guid ? "rgba(0,152,207,0.10)" : "transparent",
                                            padding: "12px",
                                            cursor: "pointer",
                                            color: "#00427C",
                                            fontSize: 15,
                                            direction: "rtl",
                                        }}
                                    >
                                        {s.displayName}
                                    </button>
                                ))
                            )}
                        </div>
                    )}
                </div>


                {/* Continue button */}
                <button
                    onClick={handleContinue}
                    style={{
                        display: "block",
                        width: 333,
                        height: 45,
                        margin: "0 auto 24px",
                        border: "none",
                        borderRadius: 10,
                        background:
                            "linear-gradient(90deg, #DEF7FF -11.26%, #0098CF 34.16%, #173E6B 100%)",
                        boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                        color: "#FFF",
                        fontSize: 18,
                        cursor: "pointer",
                    }}
                >
                    המשך
                </button>

                {/* Footer */} <img
                src="/bIcon.jpeg"
                alt=""
                style={{
                    position: "absolute",
                    marginTop: "5%",                     // nudge down from the top of footer
                    left: "50%",
                    transform: "translateX(-50%) rotate(-45deg)",
                    width: "100vh",                  // match your design scale
                    opacity: 0.05,               // very faint
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />
                <footer
                    style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        height: 150,                  // give it enough room for the icon
                        overflow: "hidden",
                        borderTopLeftRadius: 22,
                        borderTopRightRadius: 22,
                        background: "rgba(0,152,207,0.23)",
                        boxShadow: "0px 4px 13px rgba(8,25,40,0.22)",
                    }}
                >


                    <div
                        style={{
                            width: 333,
                            margin: "0 auto",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "20px",
                            flexDirection: "column",
                            gap: 6,
                        }}
                    >
                        <p
                            style={{
                                margin: 0,
                                color: "#00427C",
                                fontSize: 14,
                            }}
                        >
                            שעה נוכחית:{" "}
                            <span style={{fontWeight: 600}}>
                  {clock}
                </span>
                        </p>
                        <p
                            style={{
                                margin: 0,
                                color: "#00427C",
                                fontSize: 12,
                                opacity: 0.8,
                            }}
                        >
                            © BluePT {new Date().getFullYear()}
                        </p>
                        <Link to="/privacy-policy" style={{ margin: 0, color: "#0098CF", fontSize: 12, textDecoration: "underline" }}>
                            מדיניות פרטיות
                        </Link>
                    </div>
                </footer>
            </>
            )}
            </div>
        );
        };

          export default SiteSelection;
